import React from "react";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";
import DropdownButton from "../../../components/dropdown/DropdownButton";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import { formataData } from "../../../helpers/mesesHelper";
import Format from "../../../helpers/Format";
import Badge from "../../../components/Common/Badge";
import { AppContext } from "../../../contexts/AppContext";
import CommonButton from "../../../components/buttons/CommonButton";
import TabHelper from "../../../helpers/TabHelper";
import PropTypes from "prop-types";

function Ferias({
  linhas,
  togFeriasModal,
  togDocumentoModal,
  downloadDocumento,
  excluirFerias,
  tabHook,
  editavel,
  salvaColaborador,
  retornar,
}) {
  const { session } = React.useContext(AppContext);
  const { tabAtual, setTabAtual } = tabHook;

  const colunas = React.useMemo(
    () => [
      {
        Header: "Período aquisitivo",
        disableSortBy: true,
        accessor: (row) => {
          return row.periodo_aquisitivo_inicio && row.periodo_aquisitivo_fim
            ? `${formataData(row.periodo_aquisitivo_inicio)} até ${formataData(
                row.periodo_aquisitivo_fim
              )}`
            : null;
        },
      },
      {
        Header: "Período de férias",
        disableSortBy: true,
        accessor: (row) => {
          return `${formataData(row.periodo_ferias_inicio)} até ${formataData(
            row.periodo_ferias_fim
          )}`;
        },
      },
      {
        Header: "Dias de férias",
        disableSortBy: true,
        accessor: "dias_ferias",
      },
      {
        Header: "Data de pagamento",
        disableSortBy: true,
        accessor: (row) => {
          return formataData(row.data_pagamento);
        },
      },
      {
        Header: "Valor",
        disableSortBy: true,
        accessor: (row) => {
          return Format.formataValor(row.valor);
        },
      },
      {
        Header: "Status",
        disableSortBy: true,
        Cell: ({ row }) => {
          let status = [];

          if (parseInt(row.original.status) === 0)
            status.push(<Badge color="warning">Pendente</Badge>);
          else status.push(<Badge color="success">Disponibilizado</Badge>);

          return status;
        },
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => {
          var status = [];

          if (row.original.arquivo)
            status.push(
              <>
                <DropdownButton
                  key={`visualizar-${row.original.uid}`}
                  onClick={() => {
                    togDocumentoModal(
                      row.original.arquivo.split(".")[0],
                      row.original.arquivo.split(".")[1]
                    );
                  }}
                  color="primary"
                  icon="mdi mdi-file-search"
                >
                  Visualizar
                </DropdownButton>
                <DropdownButton
                  key={`download-${row.original.uid}`}
                  onClick={() => {
                    downloadDocumento(
                      row.original.arquivo.split(".")[0],
                      row.original.arquivo.split(".")[1]
                    );
                  }}
                  color="success"
                  icon="mdi mdi-cloud-download"
                >
                  Download
                </DropdownButton>
              </>
            );

          if (parseInt(session?.codigo) === 99)
            status.push(
              <>
                <DropdownButton
                  key={`inserir-dados-${row.original.uid}`}
                  onClick={() => {
                    togFeriasModal(row.original.uid);
                  }}
                  color="warning"
                  icon="mdi mdi-cloud-download"
                >
                  Inserir dados
                </DropdownButton>
                <DropdownButton
                  key={`excluir-${row.original.uid}`}
                  onClick={() => {
                    excluirFerias(row.original.uid);
                  }}
                  color="danger"
                  icon="mdi mdi-delete"
                >
                  Excluir
                </DropdownButton>
              </>
            );

          return <CommonDropdown>{status}</CommonDropdown>;
        },
      },
    ],
    [
      downloadDocumento,
      excluirFerias,
      session?.codigo,
      togDocumentoModal,
      togFeriasModal,
    ]
  );

  return (
    <>
      <div className="row">
        <div className="col mb-3">
          <CommonDataTable colunas={colunas} linhas={linhas} />
        </div>
      </div>
      <div className="row mb-3 mx-0">
        <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-1">
          <CommonButton
            onClick={() => {
              TabHelper.trocarTab(tabAtual, setTabAtual, -1);
            }}
            color="primary"
          >
            Anterior
          </CommonButton>
          <div className="d-flex flex-column flex-md-row align-items-center gap-1">
            <CommonButton onClick={retornar} color="danger">
              Voltar
            </CommonButton>
            {editavel ? (
              <CommonButton onClick={salvaColaborador} color="success">
                Salvar
              </CommonButton>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}

Ferias.propTypes = {
  linhas: PropTypes.arrayOf(PropTypes.object).isRequired,
  togFeriasModal: PropTypes.func.isRequired,
  togDocumentoModal: PropTypes.func.isRequired,
  downloadDocumento: PropTypes.func.isRequired,
  excluirFerias: PropTypes.func.isRequired,
  tabHook: PropTypes.shape({
    tabAtual: PropTypes.number.isRequired,
    setTabAtual: PropTypes.func.isRequired,
  }).isRequired,
  editavel: PropTypes.bool.isRequired,
  salvaColaborador: PropTypes.func.isRequired,
  retornar: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default Ferias;
